export const APP_ELEMENT_ID = 'root';
